import { Component, OnInit, Input, ViewContainerRef, ComponentFactoryResolver, ViewChild, OnChanges, SimpleChange, Output, EventEmitter, OnDestroy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { AdCardComponent } from './ad-card/ad-card.component';
import { AdComponent } from './ad.component';
import { PersonCardComponent } from './person-card/person-card.component';

@Component({
  selector: 'card',
  template: `<div #container></div>`,
  host: {
    "(click)": "onClick($event)"
  }
})

export class CardComponent implements OnInit, OnDestroy, OnChanges { 

  @Input() type : any = 'ad';
  @Input() data : any = {};
  @Input() template = 'default';
  @Input() loading = {};
  @Input() extra:any = {};
  @Input() scroll = null;
  @Input() tagClass = '';
  @Input() actionForward = '';
  @Output() callback = new EventEmitter();
  
  @ViewChild("container", { static:true,  read: ViewContainerRef }) container;
  
  private component : any;

  private components = {
      'ad'           : AdCardComponent,
      'person'       : PersonCardComponent,
      'advertise'    : PersonCardComponent
  };

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private cd: ChangeDetectorRef,
    protected el: ElementRef
    ) { 
      
  }

  ngOnInit() {
    if(this.data?._source)
      this.data = {...this.data._source, inner_hits : this.data?.inner_hits};
     
    //this.data.loading = true;
    this.data.ad = this.type;

    this.container.clear();
    
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.getComponent())
    this.component = this.container.createComponent(componentFactory);

    (<AdComponent>this.component.instance).scroll = this.scroll;
    (<AdComponent>this.component.instance).template = this.template;
    (<AdComponent>this.component.instance).extra = this.extra;
    (<AdComponent>this.component.instance).actionForward = this.actionForward;
    (<AdComponent>this.component.instance).callback.subscribe(v=> this.callback.emit(v));
    (<AdComponent>this.component.instance).data = this.data;
    if(this.template=='featured')      (<AdComponent>this.component.instance).loadAd();    
  }

  ngOnDestroy(){
    this.component.destroy();
  }

  async ngOnChanges(changes: { [key: string]: SimpleChange }) {
    if(changes?.data?.currentValue && !changes.firstChange && this.component && changes?.template?.currentValue != 'admin'){
//      if(await this.imageLoading()){
        this.data = changes.data.currentValue;
        if(this.data?._source)
          this.data = {...this.data._source, inner_hits : this.data?.inner_hits};

        this.data.ad = this.type;
        (<AdComponent>this.component.instance).data = this.data;
        (<AdComponent>this.component.instance).loadAd();
      //}

    }

    if(changes?.actionForward && this.component)
      (<AdComponent>this.component.instance).actionForward = changes.actionForward.currentValue;

    if(changes?.tagClass && this.component)
      (<AdComponent>this.component.instance).tagClass = changes.tagClass.currentValue;

    if(changes?.template && this.component)
      (<AdComponent>this.component.instance).template = changes.template.currentValue;
      
    this.cd.detectChanges();
  }

  getComponent(){
    return this.components[this.data.ad];
  }

  onClick(e) {
    if(this.data?.loading)
        return;

    (<AdComponent>this.component.instance).callback.emit(e);
    //(<AdComponent>this.component.instance).view(e);
  }

  async imageLoading(){
    await Array.prototype.map.call(this.el.nativeElement.getElementsByTagName('ion-img'), (item:HTMLElement) => {
      item.classList.remove('loaded');
      item.shadowRoot.children[0].removeAttribute('src');
    });

    return true;
  }

}

